/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const FolderNewDocument = gql`
    mutation FolderNew($title: String!, $url: String!, $parentFolder: Int, $parentDomain: Int) {
  folderNew(
    title: $title
    url: $url
    parentFolder: $parentFolder
    parentDomain: $parentDomain
  ) {
    id
  }
}
    `;
export type FolderNewMutationFn = Apollo.MutationFunction<FolderNewMutation, FolderNewMutationVariables>;

/**
 * __useFolderNewMutation__
 *
 * To run a mutation, you first call `useFolderNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderNewMutation, { data, loading, error }] = useFolderNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      parentFolder: // value for 'parentFolder'
 *      parentDomain: // value for 'parentDomain'
 *   },
 * });
 */
export function useFolderNewMutation(baseOptions?: Apollo.MutationHookOptions<FolderNewMutation, FolderNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderNewMutation, FolderNewMutationVariables>(FolderNewDocument, options);
      }
export type FolderNewMutationHookResult = ReturnType<typeof useFolderNewMutation>;
export type FolderNewMutationResult = Apollo.MutationResult<FolderNewMutation>;
export type FolderNewMutationOptions = Apollo.BaseMutationOptions<FolderNewMutation, FolderNewMutationVariables>;
export const FolderDeleteDocument = gql`
    mutation FolderDelete($folderId: Int!) {
  folderDelete(folderId: $folderId) {
    redirectPath
    statusCode
    params
  }
}
    `;
export type FolderDeleteMutationFn = Apollo.MutationFunction<FolderDeleteMutation, FolderDeleteMutationVariables>;

/**
 * __useFolderDeleteMutation__
 *
 * To run a mutation, you first call `useFolderDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderDeleteMutation, { data, loading, error }] = useFolderDeleteMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useFolderDeleteMutation(baseOptions?: Apollo.MutationHookOptions<FolderDeleteMutation, FolderDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderDeleteMutation, FolderDeleteMutationVariables>(FolderDeleteDocument, options);
      }
export type FolderDeleteMutationHookResult = ReturnType<typeof useFolderDeleteMutation>;
export type FolderDeleteMutationResult = Apollo.MutationResult<FolderDeleteMutation>;
export type FolderDeleteMutationOptions = Apollo.BaseMutationOptions<FolderDeleteMutation, FolderDeleteMutationVariables>;
export const FolderShowDocument = gql`
    query FolderShow($folderId: Int!, $page: Int, $limit: Int, $search: String) {
  folderShow(folderId: $folderId, page: $page, limit: $limit, search: $search) {
    itFolder
    folder {
      user {
        id
        email
      }
      id
      title
      url
      accessFolderDomainByPriority
      domain {
        id
        title
        accessDomain
        userAccesses {
          id
          accessType
          user {
            id
            email
          }
        }
      }
      parentFolder {
        id
        title
      }
      userAccesses {
        id
        accessType
        email
        user {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useFolderShowQuery__
 *
 * To run a query within a React component, call `useFolderShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderShowQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFolderShowQuery(baseOptions: Apollo.QueryHookOptions<FolderShowQuery, FolderShowQueryVariables> & ({ variables: FolderShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderShowQuery, FolderShowQueryVariables>(FolderShowDocument, options);
      }
export function useFolderShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderShowQuery, FolderShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderShowQuery, FolderShowQueryVariables>(FolderShowDocument, options);
        }
// @ts-ignore
export function useFolderShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FolderShowQuery, FolderShowQueryVariables>): Apollo.UseSuspenseQueryResult<FolderShowQuery, FolderShowQueryVariables>;
export function useFolderShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderShowQuery, FolderShowQueryVariables>): Apollo.UseSuspenseQueryResult<FolderShowQuery | undefined, FolderShowQueryVariables>;
export function useFolderShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderShowQuery, FolderShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderShowQuery, FolderShowQueryVariables>(FolderShowDocument, options);
        }
export type FolderShowQueryHookResult = ReturnType<typeof useFolderShowQuery>;
export type FolderShowLazyQueryHookResult = ReturnType<typeof useFolderShowLazyQuery>;
export type FolderShowSuspenseQueryHookResult = ReturnType<typeof useFolderShowSuspenseQuery>;
export type FolderShowQueryResult = Apollo.QueryResult<FolderShowQuery, FolderShowQueryVariables>;
export const FolderEditDocument = gql`
    mutation FolderEdit($folderId: Int!, $title: String!, $url: String!, $domainId: Int) {
  folderEdit(folderId: $folderId, title: $title, url: $url, domainId: $domainId) {
    id
    title
  }
}
    `;
export type FolderEditMutationFn = Apollo.MutationFunction<FolderEditMutation, FolderEditMutationVariables>;

/**
 * __useFolderEditMutation__
 *
 * To run a mutation, you first call `useFolderEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderEditMutation, { data, loading, error }] = useFolderEditMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useFolderEditMutation(baseOptions?: Apollo.MutationHookOptions<FolderEditMutation, FolderEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderEditMutation, FolderEditMutationVariables>(FolderEditDocument, options);
      }
export type FolderEditMutationHookResult = ReturnType<typeof useFolderEditMutation>;
export type FolderEditMutationResult = Apollo.MutationResult<FolderEditMutation>;
export type FolderEditMutationOptions = Apollo.BaseMutationOptions<FolderEditMutation, FolderEditMutationVariables>;
export const FolderMoveDocument = gql`
    mutation FolderMove($folderId: Int!, $domainId: Int!, $toFolderId: Int) {
  folderMove(folderId: $folderId, domainId: $domainId, toFolderId: $toFolderId) {
    redirectPath
    statusCode
    params
  }
}
    `;
export type FolderMoveMutationFn = Apollo.MutationFunction<FolderMoveMutation, FolderMoveMutationVariables>;

/**
 * __useFolderMoveMutation__
 *
 * To run a mutation, you first call `useFolderMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderMoveMutation, { data, loading, error }] = useFolderMoveMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      toFolderId: // value for 'toFolderId'
 *   },
 * });
 */
export function useFolderMoveMutation(baseOptions?: Apollo.MutationHookOptions<FolderMoveMutation, FolderMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderMoveMutation, FolderMoveMutationVariables>(FolderMoveDocument, options);
      }
export type FolderMoveMutationHookResult = ReturnType<typeof useFolderMoveMutation>;
export type FolderMoveMutationResult = Apollo.MutationResult<FolderMoveMutation>;
export type FolderMoveMutationOptions = Apollo.BaseMutationOptions<FolderMoveMutation, FolderMoveMutationVariables>;
export const FolderByDomainDocument = gql`
    query FolderByDomain($domainId: Int!) {
  folderByDomain(domainId: $domainId) {
    domain {
      id
      title
      folders {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useFolderByDomainQuery__
 *
 * To run a query within a React component, call `useFolderByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderByDomainQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useFolderByDomainQuery(baseOptions: Apollo.QueryHookOptions<FolderByDomainQuery, FolderByDomainQueryVariables> & ({ variables: FolderByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderByDomainQuery, FolderByDomainQueryVariables>(FolderByDomainDocument, options);
      }
export function useFolderByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderByDomainQuery, FolderByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderByDomainQuery, FolderByDomainQueryVariables>(FolderByDomainDocument, options);
        }
// @ts-ignore
export function useFolderByDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FolderByDomainQuery, FolderByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<FolderByDomainQuery, FolderByDomainQueryVariables>;
export function useFolderByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderByDomainQuery, FolderByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<FolderByDomainQuery | undefined, FolderByDomainQueryVariables>;
export function useFolderByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderByDomainQuery, FolderByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderByDomainQuery, FolderByDomainQueryVariables>(FolderByDomainDocument, options);
        }
export type FolderByDomainQueryHookResult = ReturnType<typeof useFolderByDomainQuery>;
export type FolderByDomainLazyQueryHookResult = ReturnType<typeof useFolderByDomainLazyQuery>;
export type FolderByDomainSuspenseQueryHookResult = ReturnType<typeof useFolderByDomainSuspenseQuery>;
export type FolderByDomainQueryResult = Apollo.QueryResult<FolderByDomainQuery, FolderByDomainQueryVariables>;
export const FolderDuplicateDocument = gql`
    mutation FolderDuplicate($folderId: Int!, $newFolderId: Int, $domainId: Int) {
  folderDuplicate(
    folderId: $folderId
    newFolderId: $newFolderId
    domainId: $domainId
  ) {
    redirectPath
    statusCode
    params
  }
}
    `;
export type FolderDuplicateMutationFn = Apollo.MutationFunction<FolderDuplicateMutation, FolderDuplicateMutationVariables>;

/**
 * __useFolderDuplicateMutation__
 *
 * To run a mutation, you first call `useFolderDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderDuplicateMutation, { data, loading, error }] = useFolderDuplicateMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      newFolderId: // value for 'newFolderId'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useFolderDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<FolderDuplicateMutation, FolderDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderDuplicateMutation, FolderDuplicateMutationVariables>(FolderDuplicateDocument, options);
      }
export type FolderDuplicateMutationHookResult = ReturnType<typeof useFolderDuplicateMutation>;
export type FolderDuplicateMutationResult = Apollo.MutationResult<FolderDuplicateMutation>;
export type FolderDuplicateMutationOptions = Apollo.BaseMutationOptions<FolderDuplicateMutation, FolderDuplicateMutationVariables>;
export const FoldersUserDocument = gql`
    query FoldersUser($search: String, $page: Int, $limit: Int) {
  foldersUser(search: $search, page: $page, limit: $limit) {
    folders {
      id
      title
      url
      parentFolder {
        id
      }
      domain {
        id
      }
      accessFolderDomainByPriority
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useFoldersUserQuery__
 *
 * To run a query within a React component, call `useFoldersUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersUserQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFoldersUserQuery(baseOptions?: Apollo.QueryHookOptions<FoldersUserQuery, FoldersUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoldersUserQuery, FoldersUserQueryVariables>(FoldersUserDocument, options);
      }
export function useFoldersUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoldersUserQuery, FoldersUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoldersUserQuery, FoldersUserQueryVariables>(FoldersUserDocument, options);
        }
// @ts-ignore
export function useFoldersUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FoldersUserQuery, FoldersUserQueryVariables>): Apollo.UseSuspenseQueryResult<FoldersUserQuery, FoldersUserQueryVariables>;
export function useFoldersUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoldersUserQuery, FoldersUserQueryVariables>): Apollo.UseSuspenseQueryResult<FoldersUserQuery | undefined, FoldersUserQueryVariables>;
export function useFoldersUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoldersUserQuery, FoldersUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FoldersUserQuery, FoldersUserQueryVariables>(FoldersUserDocument, options);
        }
export type FoldersUserQueryHookResult = ReturnType<typeof useFoldersUserQuery>;
export type FoldersUserLazyQueryHookResult = ReturnType<typeof useFoldersUserLazyQuery>;
export type FoldersUserSuspenseQueryHookResult = ReturnType<typeof useFoldersUserSuspenseQuery>;
export type FoldersUserQueryResult = Apollo.QueryResult<FoldersUserQuery, FoldersUserQueryVariables>;
export const FolderDescendantsDocument = gql`
    query FolderDescendants($folderIds: [Int!]!) {
  folderDescendants(folderIds: $folderIds) {
    childrenFolders {
      id
      title
    }
  }
}
    `;

/**
 * __useFolderDescendantsQuery__
 *
 * To run a query within a React component, call `useFolderDescendantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderDescendantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderDescendantsQuery({
 *   variables: {
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useFolderDescendantsQuery(baseOptions: Apollo.QueryHookOptions<FolderDescendantsQuery, FolderDescendantsQueryVariables> & ({ variables: FolderDescendantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderDescendantsQuery, FolderDescendantsQueryVariables>(FolderDescendantsDocument, options);
      }
export function useFolderDescendantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderDescendantsQuery, FolderDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderDescendantsQuery, FolderDescendantsQueryVariables>(FolderDescendantsDocument, options);
        }
// @ts-ignore
export function useFolderDescendantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FolderDescendantsQuery, FolderDescendantsQueryVariables>): Apollo.UseSuspenseQueryResult<FolderDescendantsQuery, FolderDescendantsQueryVariables>;
export function useFolderDescendantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderDescendantsQuery, FolderDescendantsQueryVariables>): Apollo.UseSuspenseQueryResult<FolderDescendantsQuery | undefined, FolderDescendantsQueryVariables>;
export function useFolderDescendantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderDescendantsQuery, FolderDescendantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderDescendantsQuery, FolderDescendantsQueryVariables>(FolderDescendantsDocument, options);
        }
export type FolderDescendantsQueryHookResult = ReturnType<typeof useFolderDescendantsQuery>;
export type FolderDescendantsLazyQueryHookResult = ReturnType<typeof useFolderDescendantsLazyQuery>;
export type FolderDescendantsSuspenseQueryHookResult = ReturnType<typeof useFolderDescendantsSuspenseQuery>;
export type FolderDescendantsQueryResult = Apollo.QueryResult<FolderDescendantsQuery, FolderDescendantsQueryVariables>;
export type FolderNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
  url: Types.Scalars['String']['input'];
  parentFolder?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  parentDomain?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FolderNewMutation = { __typename?: 'Mutation', folderNew: { __typename?: 'GraphFolder', id: number } };

export type FolderDeleteMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
}>;


export type FolderDeleteMutation = { __typename?: 'Mutation', folderDelete: { __typename?: 'GraphRedirect', redirectPath: string, statusCode: number, params: string } };

export type FolderShowQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FolderShowQuery = { __typename?: 'Query', folderShow: { __typename?: 'GraphPathUserFolderShow', itFolder: boolean, folder: { __typename?: 'GraphFolder', id: number, title: string, url?: string | null, accessFolderDomainByPriority: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null, domain?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, accessDomain: number, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } | null, parentFolder?: { __typename?: 'GraphFolder', id: number, title: string } | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, email?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } } };

export type FolderEditMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  title: Types.Scalars['String']['input'];
  url: Types.Scalars['String']['input'];
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FolderEditMutation = { __typename?: 'Mutation', folderEdit: { __typename?: 'GraphFolder', id: number, title: string } };

export type FolderMoveMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  domainId: Types.Scalars['Int']['input'];
  toFolderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FolderMoveMutation = { __typename?: 'Mutation', folderMove: { __typename?: 'GraphRedirect', redirectPath: string, statusCode: number, params: string } };

export type FolderByDomainQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type FolderByDomainQuery = { __typename?: 'Query', folderByDomain: Array<{ __typename?: 'GraphFolder', domain?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, folders: Array<{ __typename?: 'GraphFolder', id: number, title: string }> } | null }> };

export type FolderDuplicateMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  newFolderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FolderDuplicateMutation = { __typename?: 'Mutation', folderDuplicate: { __typename?: 'GraphRedirect', redirectPath: string, statusCode: number, params: string } };

export type FoldersUserQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FoldersUserQuery = { __typename?: 'Query', foldersUser: { __typename?: 'GraphFolders', folders: Array<{ __typename?: 'GraphFolder', id: number, title: string, url?: string | null, accessFolderDomainByPriority: number, parentFolder?: { __typename?: 'GraphFolder', id: number } | null, domain?: { __typename?: 'GraphDomain', id?: number | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type FolderDescendantsQueryVariables = Types.Exact<{
  folderIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type FolderDescendantsQuery = { __typename?: 'Query', folderDescendants: Array<{ __typename?: 'GraphFolder', childrenFolders: Array<{ __typename?: 'GraphFolder', id: number, title: string }> }> };
